import React from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import ColoredChips from "shared-ui/src/theme/extensions/ColoredChips";
import Box from "@mui/material/Box";

interface NewsCenterHeaderProps {
  title: string;
  tags: string[];
}

const NewsCenterHeader = ({ title, tags }: NewsCenterHeaderProps) => {

  return (
    <Grid container flexDirection={"column"} py={3}>
      <Box pb={2}>
        <Typography
          component="div"
          variant="h6"
          color={"text.primary"}
        >
          {title}
        </Typography>
      </Box>
      <Grid item container gap={1}>
        {tags.map((tag) => {
          return (
            <ColoredChips
              key={tag}
              label={tag}
              size="small"
            />
          );
        })}
      </Grid>
    </Grid>
  );
};

export default NewsCenterHeader;